export default __webpack_public_path__ + "static/media/fs-ii-fast.678c4fb9.svg";